// @generated by protoc-gen-es v2.16.0 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file trails_lat/proto/images.proto (package lat.trails, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file trails_lat/proto/images.proto.
 */
export const file_trails_lat_proto_images = /*@__PURE__*/
  fileDesc("Ch10cmFpbHNfbGF0L3Byb3RvL2ltYWdlcy5wcm90bxIKbGF0LnRyYWlscyLlAQoTVXBsb2FkSW1hZ2VSZXNwb25zZRIjChZjYXB0dXJlZF9lcG9jaF9zZWNvbmRzGAEgASgDSACIAQESCgoCaWQYAiABKAkSPwoIbG9jYXRpb24YAyABKAsyKC5sYXQudHJhaWxzLlVwbG9hZEltYWdlUmVzcG9uc2UuTG9jYXRpb25IAYgBARo0CghMb2NhdGlvbhITCgtsYXRfZGVncmVlcxgBIAEoARITCgtsbmdfZGVncmVlcxgCIAEoAUIZChdfY2FwdHVyZWRfZXBvY2hfc2Vjb25kc0ILCglfbG9jYXRpb25CFAoQbGF0LnRyYWlscy5wcm90b1ABYgZwcm90bzM");

/**
 * Describes the message lat.trails.UploadImageResponse.
 * Use `create(UploadImageResponseSchema)` to create a new message.
 */
export const UploadImageResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_images, 0);

/**
 * Describes the message lat.trails.UploadImageResponse.Location.
 * Use `create(UploadImageResponse_LocationSchema)` to create a new message.
 */
export const UploadImageResponse_LocationSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_images, 0, 0);

